export default __webpack_public_path__ + "static/media/ShiftsPending.666b8b5d.svg";